/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Transitions
---------------------------------------- */

import * as transition from '@router/transitions/transition';

/* ----------------------------------------
    In Viewport
---------------------------------------- */

const inView = (el, offset = true) => {
    const bounding = el.getBoundingClientRect();
    const elHeight = offset ? el.offsetHeight * 0.35 : 0;
    return bounding.top - window.innerHeight + elHeight < 0 && bounding.bottom > 0;
};

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    props: {
        content: Object,
        options: Object
    },

    data() {
        return {
            animated: false,
            events: {}
        }
    },

    computed: {
        color() {
            return this.$parent.color;
        },

        id() {
            return this.options.id || '';
        },

        size() {
            return 'block--' + this.options.size;
        },

        position() {
            const pos = this.options.position;
            return pos ? 'text-block--' + pos : '';
        }
    },

    mounted() {
        if(this.$options.reveal && !this.$options.customReveal) this.$el.style.opacity = 0;

        this.events['scroll'] = e => {
            if(inView(this.$el) && !this.animated) {
                this.animated = true;
                this.$options.reveal && this.$options.reveal(this.$el, transition.blocks, this);
            }

            if(inView(this.$el, false)) {
                this.$options.view && this.$options.view(e, this.$el.getBoundingClientRect(), this);
            }
        };

        window.addEventListener('scroll', this.events.scroll);
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.events['scroll']);
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class BlockMixin extends Vue {}